/* eslint-disable no-constant-condition */

import { MdCurrencyRupee } from "react-icons/md";
import { useToast } from "../../../context/toast-context";
import {
  Button,
  Col,
  Divider,
  Flex,
  Gap,
  InputField,
  Row,
  SelectField,
  Typography,
} from "../../../ppui";
import AllowanceList from "./allowance-list";
import {
  // HOLIDAY_LIST,
  PAY_AND_BENEFITS_CONST,
  SALARY_KNOWN_BASIC,
  SALARY_KNOWN_CTC,
  SALARY_TYPE_SALARY,
} from "./pay-benefit-const";
import SalaryDetailsView from "./salary-details-view";
import { EmployeePayandBenefits } from "./use-pay-benefits-service";

const PayAndBenefitsEmployee = () => {
  const { showToastMessage } = useToast();
  const serviceProps = EmployeePayandBenefits();

  const {
    getInputFieldPropsFn,
    employeePayBenefits,
    SalaryBreakdownOpen,
    performanceAmount,
    setTargetpath,
    employeeId,
    orgDetails,
    benefitViewData,
    setUseractionbutton
  } = serviceProps;
  return (
    <>
      <Typography variant="h5">Salary Structure</Typography>
          <Row rowGap>
          <Col sm={12} md={4} lg={4} xl={4} xxl={3}>
            <SelectField
              {...getInputFieldPropsFn(PAY_AND_BENEFITS_CONST.salary_type.name)}
            />
          </Col>
          {employeePayBenefits?.salary_type === SALARY_TYPE_SALARY ? 
            <>
              <Col sm={12} md={4} lg={4} xl={4} xxl={3}>
                <SelectField
                  {...getInputFieldPropsFn(PAY_AND_BENEFITS_CONST.salary_known.name)}
                />
              </Col>

              {employeePayBenefits?.salary_known === SALARY_KNOWN_CTC && 
              <>
                <Col sm={12} md={4} lg={4} xl={4} xxl={3}>
                  <InputField
                    {...getInputFieldPropsFn(PAY_AND_BENEFITS_CONST.ctc_salary.name)}
                    disabled={employeePayBenefits?.salary_known === SALARY_KNOWN_BASIC}
                    suffix={<MdCurrencyRupee />}
                    {...(employeePayBenefits?.ctc_salary && { value: Math.round(employeePayBenefits?.ctc_salary) })}
                  />
                </Col>
                <Col sm={12} md={4} lg={4} xl={4} xxl={3}>
                  <InputField
                    {...getInputFieldPropsFn(PAY_AND_BENEFITS_CONST.basic_percentage.name)}
                    valueSinc
                  />
                </Col>
              </>
              }
              <Col sm={12} md={4} lg={4} xl={4} xxl={3}>
                <InputField
                  {...getInputFieldPropsFn(PAY_AND_BENEFITS_CONST.basic_salary.name)}
                  valueSinc={employeePayBenefits?.basic_salary}
                  disabled={employeePayBenefits?.salary_known === SALARY_KNOWN_CTC}
                  suffix={<MdCurrencyRupee />}
                  value={employeePayBenefits?.basic_salary}
                />
              </Col>
            </>
            :
            <>
              <Col sm={12} md={4} lg={4} xl={4} xxl={3}>
                <SelectField
                  {...getInputFieldPropsFn(PAY_AND_BENEFITS_CONST.wages_payment_mode.name)}
                />
              </Col>
              <Col sm={12} md={4} lg={4} xl={4} xxl={3}>
                <SelectField
                  {...getInputFieldPropsFn(PAY_AND_BENEFITS_CONST.wages_type.name)}

                />
              </Col>
            
              <Col sm={12} md={4} lg={4} xl={4} xxl={3}>
                <InputField
                  {...getInputFieldPropsFn(PAY_AND_BENEFITS_CONST.wages_rate.name)}

                />
              </Col>
              <Col sm={12} md={4} lg={4} xl={4} xxl={3}>
                <InputField
                  {...getInputFieldPropsFn(PAY_AND_BENEFITS_CONST.wages_day.name)}

                />
              </Col>

              <Col sm={12} md={4} lg={4} xl={4} xxl={3}>
                <InputField
                  {...getInputFieldPropsFn(PAY_AND_BENEFITS_CONST.basic_salary.name)}
                  disabled={employeePayBenefits?.salary_type==='wages'}
                  suffix={<MdCurrencyRupee />}
                />
              </Col>
            </>
          }
          <Col sm={12} md={4} lg={4} xl={4} xxl={3}>
            <SelectField
              {...getInputFieldPropsFn(PAY_AND_BENEFITS_CONST.payment_mode.name)}

            />
          </Col>
          {
            benefitViewData?.ot_application && 
            <Col sm={12} md={4} lg={4} xl={4} xxl={3}>
            <InputField
              {...getInputFieldPropsFn(PAY_AND_BENEFITS_CONST.ot_rate.name)}
              disabled={!benefitViewData?.ot_application}
            />
          </Col>
          }
    
          {
            orgDetails?.
            is_allow_lwf &&    <Col sm={12} md={4} lg={4} xl={4} xxl={3}>
         
            <SelectField
              {...getInputFieldPropsFn(
                PAY_AND_BENEFITS_CONST.labour_welfare_fund.name
              )}
              disabled={!orgDetails?.
                is_allow_lwf
                }
            />
          </Col>
          }
       
        </Row>
      <Divider gap={20} />
      <AllowanceList serviceProps={serviceProps} />
      <SalaryDetailsView serviceProps={serviceProps} />
      <Gap height={20} />
      <Button   onClick={()=>{
        if(performanceAmount<0 && (serviceProps?.employeePayBenefits?.salary_type!=='wages') && (serviceProps?.employeePayBenefits?.salary_known==='ctc_salary')){
            showToastMessage({
              message:"Allowance limit exceeded.",
            color: "danger",
            })
          }else{
            SalaryBreakdownOpen()
            setUseractionbutton(true)
          }
          
          }}color="primary" variant="outlined">
        View Salary Breakdown
      </Button>
      <Gap height={50} />
      <Flex justifyContent="flex-end" gap={"10"}>
        <Button onClick={() => {}} variant="outlined">
          Cancel
        </Button>
        <Button
          color="primary"
          onClick={() => {
            if(performanceAmount<0 && (serviceProps?.employeePayBenefits?.salary_type!=='wages')&& (serviceProps?.employeePayBenefits?.salary_known==='ctc_salary')) {
              showToastMessage({
                message: "Allowance limit exceeded.",
                color: "danger",
              });
           
            } else {
              SalaryBreakdownOpen();
              setTargetpath("/employee-list")
            }
          }}
          variant="outlined"
        >
          Save & Exit
        </Button>
        <Button
          color="primary"
          onClick={() => {
            if (performanceAmount<0 && (serviceProps?.employeePayBenefits?.salary_type!=='wages'&& (serviceProps?.employeePayBenefits?.salary_known==='ctc_salary'))) {
              showToastMessage({
                message: "Allowance limit exceeded.",
                color: "danger",
              });
           
            } else {
              SalaryBreakdownOpen();
              setTargetpath(`/employee/weekly-off/${employeeId}`)
            }
          }}
          variant="contained"
        >
          Next
        </Button>
      </Flex>
    </>
  );
};

export default PayAndBenefitsEmployee;
